import { useInterfaceStore } from '../../stores/InterfaceStore';
import { isEntityIdPresentInValue } from '../../utils/evaluateExpression';
import { isDynamicValue } from '../../utils/dynamicBindings';

export function useGetShouldEvaluateResult() {
  const flags = useInterfaceStore().use.record.flags();

  return flags?.shouldReEvaluateUsingEntityIds ? isEntityIdPresentInValue : isDynamicValue;
}
